import { ICompositeProductApi } from '@canvas-logic/clp-sdk';

import React from 'react';
import { CfgUIElementState } from '@/stores/CfgUIElementState';
import { ComponentLookup } from '@/ui-kit/domain/ComponentLookup';
import { componentLookupBehaviour } from '@/ui-kit/domain/lookup/behaviours';
import { IUICfgComponent } from '@canvas-logic/clp-api-types';
import { ComponentCfgUIElement } from '@/UiBuilder/elements/ComponentCfgUIElement/ComponentCfgUIElement';

let id = 0;

export class ComponentCfgUIElementState extends CfgUIElementState {
  render(): React.ReactNode {
    return this.isViewExist ? (
      <ComponentCfgUIElement lookup={this.lookup} key={this.id} viewElement={this.viewElement} />
    ) : null;
  }

  public readonly id = 'component-view-state-' + ++id;
  public readonly lookup: ComponentLookup;
  public readonly componentKey: string;

  constructor(public readonly api: ICompositeProductApi, public readonly viewElement: IUICfgComponent) {
    super();
    const source = this.viewElement.source;
    this.componentKey = source.componentKey;
    this.lookup = new ComponentLookup(this.api, this.componentKey);
    componentLookupBehaviour(this.lookup, this);
  }

  get isViewExist() {
    if (this.viewElement.uiControl.showForTwoOrMore) {
      if (this.lookup.productData.length < 2) {
        return false;
      }
    }
    return true;
  }

  enabled() {
    return this.lookup.isEnable();
  }

  update() {
    // TODO: Optimization
    this.lookup.updateValues();
  }
}
